import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Item = ({
  children,
  className,
  testSection,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames("oui-form-field__item", className),
    "data-test-section": testSection,
    ...props,
    children
  }
);
Item.propTypes = {
  children: PropTypes.node.isRequired,
  /** CSS class names. */
  className: PropTypes.string,
  testSection: PropTypes.string
};

export { Item as default };
